import React from 'react';
import { WikiCard } from './WikiCard';
import { cn } from '../../lib/utils';

export const WikiGrid = ({ entries, category, loading, viewMode = 'grid' }) => {
    if (loading) {
        return (
            <div className={cn(
                viewMode === 'grid' 
                    ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
                    : "space-y-3"
            )}>
                {[...Array(8)].map((_, i) => (
                    <div 
                        key={i}
                        className={cn(
                            "rounded-xl bg-card dark:bg-card light:bg-white border border-white/5 dark:border-white/5 light:border-gray-200 overflow-hidden animate-pulse",
                            viewMode === 'list' && "flex items-center gap-4"
                        )}
                    >
                        <div className={cn(
                            viewMode === 'grid' ? "aspect-video bg-white/5 dark:bg-white/5 light:bg-gray-100" : "w-16 h-16 shrink-0 bg-white/5 dark:bg-white/5 light:bg-gray-100"
                        )} />
                        <div className={cn(
                            viewMode === 'grid' ? "p-5 space-y-3" : "flex-1 py-3 pr-4"
                        )}>
                            <div className="h-6 bg-white/5 dark:bg-white/5 light:bg-gray-100 rounded w-3/4" />
                            {viewMode === 'grid' && (
                                <>
                                    <div className="h-4 bg-white/5 dark:bg-white/5 light:bg-gray-100 rounded w-full" />
                                    <div className="h-4 bg-white/5 dark:bg-white/5 light:bg-gray-100 rounded w-2/3" />
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (!entries || entries.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-16 text-center">
                <div className="w-16 h-16 rounded-full bg-white/5 dark:bg-white/5 light:bg-gray-100 flex items-center justify-center mb-4">
                    <span className="text-3xl text-gray-600">📭</span>
                </div>
                <h3 className="text-xl font-['Rajdhani'] text-gray-400 dark:text-gray-400 light:text-gray-600 mb-2">
                    No entries found
                </h3>
                <p className="text-gray-500 text-sm">
                    There are no items in this category yet.
                </p>
            </div>
        );
    }

    if (viewMode === 'list') {
        return (
            <div className="space-y-2">
                {entries.map((entry, index) => (
                    <div 
                        key={entry.id}
                        className={cn(
                            "animate-fade-in opacity-0",
                            `stagger-${Math.min(index + 1, 6)}`
                        )}
                    >
                        <WikiCard entry={entry} category={category} viewMode="list" />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {entries.map((entry, index) => (
                <div 
                    key={entry.id}
                    className={cn(
                        "animate-fade-in opacity-0",
                        `stagger-${Math.min(index + 1, 6)}`
                    )}
                >
                    <WikiCard entry={entry} category={category} viewMode="grid" />
                </div>
            ))}
        </div>
    );
};
